import { useBooking } from '../../context/BookingContext';

// Booking-hold countdown banner, shown on the cruise summary (5A) and passenger
// details (5B). The remaining time is driven from the absolute hold expiry held
// in BookingContext, so it stays consistent across both screens and the T&C detour.
export default function HoldTimer() {
  const { holdSeconds } = useBooking();

  const mm = String(Math.floor(holdSeconds / 60)).padStart(2, '0');
  const ss = String(holdSeconds % 60).padStart(2, '0');

  // Urgency cue: under 5:00 remaining (less than 300s), the countdown turns a
  // tasteful red. Above 5 minutes it keeps the gold accent.
  const urgent = holdSeconds > 0 && holdSeconds < 300;

  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-[#D4A843] bg-[rgba(201,168,76,0.1)] px-5 py-4 mb-4 shrink-0">
      <div className="flex flex-col">
        <span className="font-dm-sans text-[13px] text-white/60">Booking held for</span>
        {holdSeconds > 0 ? (
          <span className={`font-cormorant text-3xl leading-none mt-1 tabular-nums ${urgent ? 'text-[#E5484D]' : 'text-[#C9A84C]'}`}>{mm}:{ss}</span>
        ) : (
          <span className="font-dm-sans text-[13px] font-medium text-[#C9A84C] mt-1.5">Your booking hold has expired</span>
        )}
      </div>
      <span className="font-dm-sans text-sm text-white font-medium text-right max-w-[160px] leading-relaxed">
        Complete your booking before time runs out
      </span>
    </div>
  );
}
